export default __webpack_public_path__ + "static/media/makemeproudamerica.dffb1d40.png";